import {Component, Input, OnInit} from '@angular/core';
export interface IReviewItem {
  name: string;
  title: string;
  text: string;
  imgSrc?: string;
}
@Component({
  selector: 'app-reviews-item',
  templateUrl: './reviews-item.component.html',
  styleUrls: ['./reviews-item.component.scss']
})
export class ReviewsItemComponent implements OnInit {

  @Input() data: IReviewItem;
  constructor() { }

  ngOnInit(): void {
  }

}
